// Where a post sits in its series, with every part one click away.
import clsx from "clsx";
import { Link } from "react-router";

import { usePosts } from "../../api/hooks";

export function SeriesNav({ series, current }: { series: string; current: string }) {
  const posts = usePosts();
  const parts = (posts.data ?? []).filter((p) => p.series === series).sort((a, b) => (a.part ?? 0) - (b.part ?? 0));
  if (parts.length < 2) return null;
  return (
    <nav aria-label={`The series ${series}`} className="card p-5">
      <p className="kicker">The series</p>
      <p className="mt-1 font-display text-lg font-bold tracking-tight">{series}</p>
      <ol className="mt-4 space-y-1">
        {parts.map((p) => (
          <li key={p.slug}>
            <Link
              to={`/blog/${p.slug}`}
              aria-current={p.slug === current ? "page" : undefined}
              className={clsx("flex gap-3 rounded-lg px-2 py-1.5 text-[14px] leading-snug transition-colors", p.slug === current ? "bg-ink text-paper" : "text-ink2 hover:bg-paper2 hover:text-ink")}
            >
              <span className={clsx("font-mono text-[12px]", p.slug === current ? "text-signal" : "text-ink3")}>{String(p.part).padStart(2, "0")}</span>
              {p.title}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  );
}
